/**
  * 公告/新闻/文章信息模块接口列表
  */

import base from '../base'; // 导入接口域名列表
import axios from '../../request/http'; // 导入http中创建的axios实例

const baseNewsinfoApi = {
    GetDataList: `${base.qa}/BaseNewsinfo/GetDataList`,
    GetPortalNewsList: `${base.qa}/BaseNewsinfo/GetPortalNewsList`,
    SaveData: `${base.qa}/BaseNewsinfo/SavePortalNews`,
    DelData: `${base.qa}/BaseNewsinfo/DelData`,
    IsShowPortal:`${base.qa}/BaseNewsinfo/IsShowPortal`,
    EditSort:`${base.qa}/BaseNewsinfo/EditSort`,
    EditTitle:`${base.qa}/BaseNewsinfo/EditTitle`,
    GetPortalNewsById:`${base.qa}/BaseNewsinfo/GetPortalNewsById`,
    upload:`${base.qa}/WebUploader/UplodeFile`,
}

const baseNewsinfo = {
    GetDataList (newstype, pageindex, pagesize) {
        return axios.get(baseNewsinfoApi.GetDataList, { params: { newstype, pageindex, pagesize } })
    },
    GetPortalNewsList(params){
        return axios.get(baseNewsinfoApi.GetPortalNewsList, { params})
    },
    GetPortalNewsById(params){
        return axios.get(baseNewsinfoApi.GetPortalNewsById, { params})
    },
    IsShowPortal(params){
        return axios.post(baseNewsinfoApi.IsShowPortal,params)
    },
    EditSort(params){
        return axios.post(baseNewsinfoApi.EditSort, params)
    },
    EditTitle(params){
        return axios.post(baseNewsinfoApi.EditTitle, params)
    },
    SaveData (params) {
        return axios.post(baseNewsinfoApi.SaveData, params)
    },
    DelData (params) {
        return axios.post(baseNewsinfoApi.DelData, params)
    },
    UploadFile (params) {
        return axios.post(baseNewsinfoApi.upload, params)
    },
}


export default baseNewsinfo;